import { IAddress } from '../interfaces/address';
import { NotificationChannel } from '../interfaces/notification-channel';

export class NotificationHelper {
  public static getRecipient(channel: NotificationChannel, address: Partial<IAddress>): string | null {
    if (channel === 'email') {
      const email: string = (address?.email ?? '').trim();

      return email.includes('@') ? email : null;
    }

    const phoneNumber: string = (address?.phoneNumber ?? '').trim();

    return phoneNumber.replace(/\D/g, '').length >= 10 ? phoneNumber : null;
  }

  public static isReachable(channel: NotificationChannel, address: Partial<IAddress>): boolean {
    return !!NotificationHelper.getRecipient(channel, address);
  }
}
